/**
 * @packageDocumentation
 * @module      DeviceInfo.ts
 * @description Encapsulates the portion of the database's DeviceInfo record that this app displays.
 * @copyright   Copyright (c) 2021 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
export default class DeviceInfo {
    constructor(systemId, deviceType, softwareVersion, lastHeard, deviceState, privateVpnIpv4) {
        this.systemId = systemId || '';
        this.deviceType = deviceType || '';
        this.softwareVersion = softwareVersion || '';
        this.lastHeard = lastHeard || new Date(0); // A long time ago.
        this.deviceState = deviceState || 'MISSING'; // Missing until someone hears from it.
        this.privateVpnIpv4 = privateVpnIpv4 || '';
    }
    get isControlSide() {
        return this.deviceType.startsWith("C");
    }
    get isPatientSide() {
        return this.deviceType.startsWith("P");
    }
    get isHealthy() {
        return this.deviceState === 'IDLE' || this.deviceState === 'ACTIVE';
    }
    toJSON() {
        const jsonObj = Object.assign({}, this);
        jsonObj.lastHeard = this.lastHeard.toISOString();
        return jsonObj;
    }
    static fromJSON(json) {
        let dev = new DeviceInfo();
        dev.systemId = json.systemId || '';
        dev.deviceType = json.deviceType || '';
        dev.softwareVersion = json.softwareVersion || '';
        dev.lastHeard = new Date(Date.parse(json.lastHeard));
        dev.deviceState = json.deviceState || 'MISSING';
        dev.privateVpnIpv4 = json.privateVpnIpv4 || '';
        return dev;
    }
}
//# sourceMappingURL=DeviceInfo.js.map